import useFormatMessage from 'hooks/useFormatMessage';
import Crashed from 'assets/vectors/error-pages/crashed.svg';
import { isArray } from 'lodash-es';
import { ErrorBase } from './ErrorBase';

export function ErrorCrashed({ message, statusCode = '', titleKey }) {
  const t = useFormatMessage();
  const title = t(titleKey);
  const messages = isArray(message) ? message : [message];

  return (
    <ErrorBase
      image={Crashed}
      messages={messages}
      statusCode={statusCode}
      title={title}
    />
  );
}
